import { BodyText } from '@unmind/design-system';
import styled from 'styled-components';
import { rem } from 'polished';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${rem(24)};
  box-sizing: border-box;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
`;

export const MicrophoneSettingsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: ${rem(40)};
`;

export const MicrophoneSettingsText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize20],
}))`
  margin-bottom: 40px;
`;

export const MicrophoneSettingsButton = styled.button`
  padding: 0;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
  background: transparent;
  -webkit-appearance: none;
`;
